import './chart.style.less'

import { Line } from 'react-chartjs-2'
import MainWrapper from './MainWrapper'
import { useState, useLayoutEffect } from 'react'
interface props {
  title: string
  sign?: string
  showLegend?: boolean
  data: any
  id: string
  periods?: string[]
  onPeriodChange?: (period: string) => any
}

function MixedLine(props: props) {
  const {
    data,
    showLegend = true,
    title,
    sign = '',
    id,
    periods,
    onPeriodChange,
  } = props

  const [plugins, setPlugins] = useState<any>()

  useLayoutEffect(() => {
    const plugins = [
      {
        id: 'liveboard',
        beforeInit: function (chart) {
          // Get reference to the original fit function
          const originalFit = chart.legend.fit
          // Override the fit function
          chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)()
            this.height += 10
          }
        },
      },
    ]

    setPlugins(plugins)
  }, [])

  const options = {
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        padding: { top: -10 },
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        align: 'end' as const,
        anchor: 'end' as const,
        padding: {
          top: 0,
        },
        formatter: (val) => {
          return val + sign
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20 },
    },
    scales: {
      x: {
        stacked: false,
      },
      y: {
        stacked: false,
        ticks: {
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  }

  return (
    <MainWrapper
      id={id}
      title={title}
      onPeriodChange={onPeriodChange}
      periods={periods}
    >
      <Line redraw data={data} options={options} plugins={plugins} />
    </MainWrapper>
  )
}
export default MixedLine
